import { useCallback, useEffect } from "react";
// import { useSearchParams } from "react-router-dom";
import { generatePropertyConfigKey } from "./use-property-config-values";
import { useQuerySearch } from "../use-query-param";

function useDefaultPropertyConfig(
  propertySlug: string,
  viewLayout: string,
  configs: PropertyConfig[],
  adultCount?: number,
  couponCode?: string,
  isInitialDetailsLoading?: boolean,
  preBookMeals?: boolean,
) {
  const [search, setSearch] = useQuerySearch();

  const handleDefaultConfig = useCallback(
    () => {
      if (!isInitialDetailsLoading) {
        return;
      }


      if (!propertySlug) {
        return;
      }

      if (viewLayout !== "package" && configs.length !== 1) {
        return;
      }

       // Always copy before mutating!
      const updatedSearch = { ...search };

      if (!adultCount) {
        return;
      }

      // Iterate over configs to identify the config which can accomodate the adult count. Check for max_occupancy is configs.
      let firstConfig = configs?.find((config) => {
        const maxOccupancy = Number(config.max_occupancy) + Number(config.room_extra_occupancy);
        return maxOccupancy >= adultCount;
      });

      // If first config not found based on adult count, use the first config
      if (!firstConfig) {
        firstConfig = configs?.[0];
      }

      const key = generatePropertyConfigKey(propertySlug, firstConfig);

      if (updatedSearch[key]) {
        return;
      }

      updatedSearch[key] = ["1"];

      setSearch(() => updatedSearch, { replace: true });
    },
    [setSearch, propertySlug, configs, adultCount, couponCode, isInitialDetailsLoading,preBookMeals],
  );

  useEffect(handleDefaultConfig, [handleDefaultConfig]);
}

export default useDefaultPropertyConfig;
